import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export function passwordMatchValidator(controlName: string, matchingControlName: string): ValidationErrors | null {
    return (formGroup: FormGroup) => {
        const control: AbstractControl<string> = formGroup.controls[controlName];
        const matchingControl: AbstractControl<string> = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    };
}
